import React from 'react';

const Spinner = props => {
  return props.loading ? (
    <div className={`spinner ${props.className}`}>
      <div className="status-bar">
      </div>
    </div>
  ) : null;
};

export default Spinner;
